import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./mobileBottom.scss";
import { FaHome } from "react-icons/fa";
import { MdOutlineContactSupport } from "react-icons/md";
import { CgProfile } from "react-icons/cg";
const MobileBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hideOnRoutes = ["/login", "/register"];
  if (hideOnRoutes.includes(location.pathname)) return null;
  return (
    <div className="mobile-bottom-nav">
      <div onClick={() => navigate("/dashboard")}>
        <FaHome style={{ fontSize: "30px", color: "#3c4b64" }} />
      </div>
      <div onClick={() => navigate("/support")}>
        <MdOutlineContactSupport
          style={{ fontSize: "30px", color: "#3c4b64" }}
        />
      </div>
      <div onClick={() => navigate("/profile")}>
        <CgProfile style={{ fontSize: "30px", color: "#3c4b64" }} />
      </div>
    </div>
  );
};

export default MobileBottomNav;
